module.exports = "https://cdn.redage.net/src/views/player/reports/images/ra-logo.png";